import Api from './api';
import FlashMessages from './flash-messages';

export interface ApiErrorFeedback {
    enable(): void
}

export default {
    enable (): void {
        Api.version(1).onError(() => {
            FlashMessages.danger('Ein Fehler ist aufgetreten, bitte versuche es später noch einmal.');
        });
    },
} as ApiErrorFeedback;
